import { FC } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NavigateFunction } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import { stylesShareSite } from "../shareSiteStylesMui/ShareSiteStylesMuiComponents";

type ShareSiteParams = {
  siteName: string;
  loadingFetchPartnerOrganisations: boolean;
  navigate: NavigateFunction;
  resetShareSiteStatement: () => void;
};

const ShareSiteMenu: FC<ShareSiteParams> = ({
  siteName,
  loadingFetchPartnerOrganisations,
  navigate,
  resetShareSiteStatement,
}) => {
  const [t] = useTranslation("global");
  return (
    <div className="menu-share-site">
      <div className="spacer-div-back-button" />
      <div className="title-share-site">{`${t(
        "Share_site.share-data-with"
      )} ${siteName}`}</div>

      <div>
        <Button
          disabled={loadingFetchPartnerOrganisations}
          sx={stylesShareSite.closeButton}
          variant="text"
          endIcon={<CloseIcon />}
          onClick={() => {
            navigate(`/site/details/${siteName}`);
            resetShareSiteStatement();
          }}
        >
          {t("Common_options.Cancel")}
        </Button>
      </div>
    </div>
  );
};

export default ShareSiteMenu;
